import { createContext } from "react";
import { OfferContextType } from "@vertical-insure/shared";

export const OfferContext = createContext<OfferContextType>({
  loading: false,
  quotes: {},
  updateProductConfig: () => {},
  acceptedQuotes: []
});
